import React from 'react'
import Constant from '../../Constant'
import BulkCouponForm from './BulkCouponForm'
import MUIDataTable from 'mui-datatables'
import Swal from 'sweetalert2'
import 'react-toggle/style.css' // for ES6 modules
import Loader from '../../common/Loader'
import axios from 'axios'
import { Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core'
import moment from 'moment'
import Toggle from 'react-toggle'
import CustomFooter from '../../common/TableBottom'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'

class BulkCoupon extends React.Component {
  state = {
    couponList: [],
    selectedCouponDetail: {},
    couponViewer: false,
    list: [],
    categoryList: [],
    isListLoading: false,
    search: {
      coupon_name: '',
      coupon_code: '',
      amount_type: '',
      amount: '',
      no_of_redeem: '',
      limit: 10,
      pageNumber: 0,
      totalPages: 0,
    },

    editCouponId: null,
    editCouponData: null,

    isSearching: false,
  }

  componentDidMount() {
    this.CouponLists()
    this.loadData()
  }

  handleStatusChange = async (id, is_active) => {
    var data = { id, is_active }
    let that = this
    await axios
      .put(Constant.getAPI() + '/admin/bulk-coupon-status-update', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Active status has been Changed', 'success')
          that.CouponLists()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleCheckoutStatusChange = async (id, show_on_checkout) => {
    var data = { id, show_on_checkout }
    let that = this
    await axios
      .put(Constant.getAPI() + '/admin/bulk-coupon-checkout-status-update', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Checkout visibility status has been changed', 'success')
          that.CouponLists()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  loadData = async () => {
    let categoryList = await axios.get(Constant.getAPI() + '/cruise/list-cruise-masters', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (
      categoryList.status == 200 &&
      categoryList.data &&
      categoryList.data.data &&
      categoryList.data.data.length > 0
    ) {
      this.setState(
        {
          categoryList: categoryList.data.data.filter((item) => item.is_active == true),
        },
        () => {
          this.state.categoryList.forEach(async (category) => {
            if (category.category_type == 'CRUISE') {
              let list = await axios.get(
                Constant.getAPI() + '/cruise/cruise-listing/' + category.cruise_cat_en + '/' + category.id,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                  },
                }
              )

              if (list.status == 200 && list.data && list.data.data && list.data.data.length > 0) {
                this.setState(
                  {
                    list: {
                      ...this.state.list,
                      [category.id]: list.data.data.filter((item) => item.is_active),
                    },
                  },
                  () => { }
                )
              }
            } else if (category.category_type == 'EVENT' || category.category_type == 'ACTIVITY') {
              let list = await axios.get(
                Constant.getAPI() + '/event-companies/event-companies-list/' + category.category_type,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                  },
                }
              )

              if (list.status == 200 && list.data) {
                this.setState(
                  {
                    list: {
                      ...this.state.list,
                      [category.id]: list.data.data.filter((item) => item.is_active) || [],
                    },
                  },
                  () => { }
                )
              }
            }
          })
        }
      )
    }
  }

  CouponLists = async () => {
    this.setState({
      isListLoading: true,
    })

    await axios
      .get(Constant.getAPI() + '/admin/list-bulk-coupon', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: this.state.search,
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            couponList: res.data.data,
            ...res.data?.pagination,
            disabled: res.data?.pagination?.next ? false : true,
            isListLoading: false,
            isSearching: false,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }

        this.setState({
          isListLoading: false,
          isSearching: false,
        })
      })
  }

  getLanguageList = () => {
    var language_data = Constant.getLanguageList()
    this.setState({
      language_data: language_data,
      language_id: language_data[0].id,
      isLoading: false,
    })
  }

  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  searchDataChange = (event) => {
    if (
      (event.target.name === 'no_of_redeem' || event.target.name === 'amount') &&
      (event.target.value < 0 || event.target.value == '-' || event.target.value == '-0')
    ) {
      return
    }

    this.setState({
      search: {
        ...this.state.search,
        [event.target.name]: event.target.value,
      },
    })
  }

  search = () => {
    this.setState({
      isSearching: true,
    })

    this.CouponLists()
  }

  reloadList = () => {
    this.setState(
      {
        search: {
          coupon_name: '',
          coupon_code: '',
          amount_type: '',
          amount: '',
          no_of_redeem: '',
        },
        editCouponId: null,
        editCouponData: null,
      },
      () => {
        this.CouponLists()
      }
    )
  }

  deleteCoupons = async (selectedRows, displayData, setSelectedRows) => {
    var couponIds = []
    for (let i = 0; i < selectedRows.data.length; i++) {
      if (
        displayData.length &&
        displayData[selectedRows.data[i].dataIndex] &&
        displayData[selectedRows.data[i].dataIndex].data &&
        displayData[selectedRows.data[i].dataIndex].data[0]
      ) {
        couponIds.push(displayData[selectedRows.data[i].dataIndex].data[0])
      }
    }

    await axios.delete(Constant.getAPI() + '/admin/delete-bulk-coupons', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
      data: {
        coupons: couponIds,
      },
    })

    this.setState({
      couponList: [],
    })

    this.CouponLists()

    Swal.fire({
      title: 'Coupons Deleted Successfully!',
      icon: 'success',
      text: '',
      type: 'success',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
    })

    setSelectedRows([])
  }

  deleteCoupon = async (couponId) => {
    await axios
      .delete(Constant.getAPI() + '/admin/delete-bulk-coupon/' + couponId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.statusCode == 200) {
          Swal.fire({
            title: 'Coupon Deleted Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          this.setState({
            couponList: this.state.couponList.filter((item) => item.id != couponId),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  showCouponDetails = (id) => {
    if (id) {
      this.setState({
        selectedCouponDetail: this.state.couponList.find((item) => item.id == id),
        couponViewer: true,
      })
    }
  }

  hideCouponDetails = () => {
    this.setState({
      couponViewer: false,
      selectedCouponDetail: {},
    })
  }

  editCoupon = (id) => {
    const coupon = this.state.couponList.find((item) => item.id == id)

    if (coupon) {
      this.setState({
        editCouponData: coupon,
        editCouponId: id,
      })
    }

    window.scrollTo(0, 0)
  }

  clearEdit = () => {
    this.setState({
      editCouponData: null,
      editCouponId: null,
    })
  }

  render() {
    const customToolbar = () => {
      return (
        <>
          <div className="row">
            <div className="col-md-2">
              <div className="form-group row p-l-15">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Coupon Code"
                  value={this.state.search.coupon_code}
                  name="coupon_code"
                  onChange={this.searchDataChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group row p-l-15">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Coupon Name"
                  value={this.state.search.coupon_name}
                  name="coupon_name"
                  onChange={this.searchDataChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group row p-l-15">
                <select
                  value={this.state.search.amount_type}
                  name="amount_type"
                  onChange={this.searchDataChange}
                  className="form-control"
                >
                  <option value="">All</option>
                  <option value="DECIMAL">Decimal</option>
                  <option value="PERCENTAGE">Percentage</option>
                  <option value="DRINK">Drink</option>
                </select>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group row p-l-15">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Coupon Amount"
                  value={this.state.search.amount}
                  name="amount"
                  onChange={this.searchDataChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group row p-l-15">
                <input
                  type="number"
                  className="form-control"
                  placeholder="No of Redeems"
                  value={this.state.search.no_of_redeem}
                  name="no_of_redeem"
                  onChange={this.searchDataChange}
                />
              </div>
            </div>
            <div className="col-md-2 justify-content-center">
              <div className="row">
                <button
                  onClick={this.reloadList}
                  className="btn hor-grd btn-grd-inverse m-l-5"
                >
                  Clear
                </button>
                {this.state.isSearching ? (
                  <button
                    className="btn btn-grd-disabled mr-2 m-l-5"
                    disabled
                  >
                    Searching..
                  </button>
                ) : (
                  <button
                    onClick={this.search}
                    className="btn hor-grd btn-grd-inverse m-l-5"
                  >
                    <i className="ti-search"></i>Search
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      )
    }

    const copyCouponCode = () => {
      const code = this.state.selectedCouponDetail?.coupon_code
      if (code) {
        navigator.clipboard.writeText(code)
        Swal.fire({
          title: 'Copied!',
          text: 'Coupon code copied to clipboard',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        })
      }
    }

    const couponViewer = () => {
      const detail = this.state.selectedCouponDetail
      if (!detail) return null

      const usagePercentage = detail.no_of_redeem > 0 
        ? ((detail.no_of_user_use / detail.no_of_redeem) * 100).toFixed(1) 
        : 0

      const isFullyRedeemed = detail.no_of_redeem === detail.no_of_user_use
      const isActive = detail.is_active

      return (
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={this.state.couponViewer}
          onClose={this.hideCouponDetails}
        >
          <DialogTitle>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mb-1">Coupon Details</h5>
                <small className="text-muted">{detail.coupon_type?.toUpperCase()} COUPON</small>
              </div>
              <div>
                {isActive ? (
                  <span className="badge badge-success mr-2">ACTIVE</span>
                ) : (
                  <span className="badge badge-secondary mr-2">INACTIVE</span>
                )}
                {isFullyRedeemed && <span className="badge badge-warning">FULLY REDEEMED</span>}
              </div>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <div className="container-fluid">
              {/* Basic Information Section */}
              <div className="mb-4">
                <h6 className="text-primary border-bottom pb-2 mb-3">
                  <i className="icofont icofont-info-circle mr-2"></i>Basic Information
                </h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Coupon Name:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">{detail.coupon_name || '--'}</div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Coupon Code:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        <code style={{ fontSize: '14px', padding: '4px 8px', background: '#f5f5f5', borderRadius: '4px' }}>
                          {detail.coupon_code || '--'}
                        </code>
                        {detail.coupon_code && (
                          <i 
                            className="icofont icofont-copy-invert ml-2 cursor-pointer" 
                            onClick={copyCouponCode}
                            title="Copy code"
                            style={{ cursor: 'pointer', color: '#007bff' }}
                          ></i>
                        )}
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Coupon Type:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        <span className="badge badge-info">{detail.coupon_type?.toUpperCase() || '--'}</span>
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Country:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        <span className="badge badge-primary">{detail.country || '--'}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Category:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.categories_names || <span className="badge badge-dark">ALL CATEGORIES</span>}
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Description:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">{detail.note || '--'}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Coupon Value Details Section */}
              <div className="mb-4">
                <h6 className="text-primary border-bottom pb-2 mb-3">
                  <i className="icofont icofont-sale-discount mr-2"></i>Coupon Value Details
                </h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Amount Type:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.amount_type ? (
                          <span className="badge badge-primary">{detail.amount_type}</span>
                        ) : '--'}
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Amount:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.amount || '--'}
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>No Of Drinks:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.no_of_drinks || '--'}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Min. Booking Amount:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.minimum_booking_amount || '--'}
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Discount Applied On:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.cruise_coupon_category ? (
                          <span className="badge badge-secondary">
                            {detail.cruise_coupon_category.toUpperCase()}
                          </span>
                        ) : (
                          <span className="badge badge-secondary">ALL</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Usage Statistics Section */}
              <div className="mb-4">
                <h6 className="text-primary border-bottom pb-2 mb-3">
                  <i className="icofont icofont-chart-bar-graph mr-2"></i>Usage Statistics
                </h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Times Used:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                          {detail.no_of_user_use || 0} / {detail.no_of_redeem || 0}
                        </span>
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Usage Progress:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        <div className="progress" style={{ height: '20px' }}>
                          <div
                            className={`progress-bar ${isFullyRedeemed ? 'bg-success' : 'bg-info'}`}
                            role="progressbar"
                            style={{ width: `${usagePercentage}%` }}
                            aria-valuenow={usagePercentage}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {usagePercentage}%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Usage Restriction:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        <span className="badge badge-warning">
                          {detail.user_allow_to_use || '--'}
                        </span>
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>New Users Only:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.new_users_only ? (
                          <span>
                            <span className="badge badge-info">YES</span>
                            <small className="text-muted ml-2">
                              (From {moment(detail.createdAt).format('DD/MM/YYYY HH:mm A')})
                            </small>
                          </span>
                        ) : (
                          <span className="badge badge-secondary">NO</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Validity Period Section */}
              <div className="mb-4">
                <h6 className="text-primary border-bottom pb-2 mb-3">
                  <i className="icofont icofont-calendar mr-2"></i>Validity Period
                </h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Creation Period:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {moment(detail.creation_start_date).format('DD/MM/YYYY')} - {moment(detail.creation_end_date).format('DD/MM/YYYY')}
                      </div>
                    </div>
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Booking Period:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {moment(detail.start_date).format('DD/MM/YYYY')} - {moment(detail.end_date).format('DD/MM/YYYY')}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Time Window:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.start_time} - {detail.end_time}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Products Included Section */}
              {detail.productsList && detail.productsList.length > 0 && (
                <div className="mb-4">
                  <h6 className="text-primary border-bottom pb-2 mb-3">
                    <i className="icofont icofont-list mr-2"></i>Applicable Products
                  </h6>
                  <div className="d-flex flex-wrap">
                    {detail.productsList.map((item, index) => (
                      <span key={index} className="badge badge-pill badge-light mr-2 mb-2" style={{ fontSize: '13px', padding: '8px 12px' }}>
                        {item.cruise_name_en} / {item.cruise_name_ar}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Status Section */}
              <div className="mb-2">
                <h6 className="text-primary border-bottom pb-2 mb-3">
                  <i className="icofont icofont-eye mr-2"></i>Display Settings
                </h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Redemption Status:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {isFullyRedeemed ? (
                          <span className="badge badge-success">FULLY REDEEMED</span>
                        ) : (
                          <span className="badge badge-info">ACTIVE ({detail.no_of_redeem - detail.no_of_user_use} remaining)</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row coupon-detail-key-style-block">
                      <div className="col-5 coupon-detail-key-style"><strong>Show on Checkout:</strong></div>
                      <div className="col-7 coupon-detail-key-value-style">
                        {detail.show_on_checkout ? (
                          <span className="badge badge-success">
                            <i className="icofont icofont-check-circled mr-1"></i>VISIBLE
                          </span>
                        ) : (
                          <span className="badge badge-secondary">
                            <i className="icofont icofont-close-circled mr-1"></i>HIDDEN
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <button
              className="btn btn-primary"
              onClick={this.hideCouponDetails}
            >
              <i className="icofont icofont-close mr-1"></i>Close
            </button>
          </DialogActions>
        </Dialog>
      )
    }

    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },
      {
        name: 'coupon_name',
        label: 'Coupon name',
        options: { filter: false, sort: true },
      },
      {
        name: 'country',
        label: 'Country',
        options: { 
          filter: true, 
          sort: true,
          customBodyRender: (value) => {
            return <span className="badge badge-primary">{value || '--'}</span>
          },
        },
      },
      {
        name: 'coupon_code',
        label: 'Coupon Code',
        options: { 
          filter: false, 
          sort: true,
          customBodyRender: (value) => {
            const handleCopy = (e) => {
              e.stopPropagation()
              navigator.clipboard.writeText(value)
              Swal.fire({
                title: 'Copied!',
                text: `Code "${value}" copied to clipboard`,
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
              })
            }
            
            return (
              <div className="d-flex align-items-center">
                <code style={{ 
                  fontSize: '13px', 
                  padding: '4px 8px', 
                  background: '#f8f9fa', 
                  borderRadius: '4px',
                  border: '1px solid #dee2e6',
                  fontWeight: 'bold'
                }}>
                  {value}
                </code>
                <i 
                  className="icofont icofont-ui-copy ml-1" 
                  onClick={handleCopy}
                  style={{ cursor: 'pointer', color: '#007bff', fontSize: '16px' }}
                  title="Copy code"
                ></i>
              </div>
            )
          },
        },
      },
      {
        name: 'coupon_type',
        label: 'Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            const badgeClass = value === 'discount' ? 'badge-primary' : 'badge-info'
            return <span className={`badge ${badgeClass}`}>{value?.toUpperCase() || '--'}</span>
          },
        },
      },
      {
        name: 'amount_type',
        label: 'Discount Value',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            const couponType = tableMeta.rowData[4]
            const amount = tableMeta.rowData[6]
            const drinks = tableMeta.rowData[7]
            
            if (couponType === 'drink') {
              return (
                <div style={{ fontWeight: 'bold', color: '#17a2b8' }}>
                  <i className="icofont icofont-beer mr-1"></i>
                  {drinks || '--'} Drinks
                </div>
              )
            }
            
            if (value === 'PERCENTAGE') {
              return (
                <div style={{ fontWeight: 'bold', color: '#28a745' }}>
                  {amount}%
                </div>
              )
            } else if (value === 'DECIMAL') {
              return (
                <div style={{ fontWeight: 'bold', color: '#28a745' }}>
                  {amount}
                </div>
              )
            }
            return '--'
          },
        },
      },
      {
        name: 'amount',
        label: 'Amount',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },
      {
        name: 'no_of_drinks',
        label: 'No Of Drinks',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },
      {
        name: 'categories_names',
        label: 'Categories',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            if (!value) {
              return <span className="badge badge-dark">ALL CATEGORIES</span>
            }
            
            const categories = value.split(',').map(cat => cat.trim())
            if (categories.length === 1) {
              return <span className="badge badge-secondary">{categories[0]}</span>
            }
            
            return (
              <div>
                <span className="badge badge-secondary">{categories[0]}</span>
                {categories.length > 1 && (
                  <span 
                    className="badge badge-light ml-1" 
                    title={categories.slice(1).join(', ')}
                    style={{ cursor: 'pointer' }}
                  >
                    +{categories.length - 1}
                  </span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'no_of_user_use',
        label: 'Usage Statistics',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            const used = value || 0
            const total = tableMeta.rowData[10] || 0
            const percentage = total > 0 ? ((used / total) * 100).toFixed(0) : 0
            const isFullyUsed = used >= total
            
            return (
              <div style={{ minWidth: '120px' }}>
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <small style={{ fontWeight: 'bold' }}>{used} / {total}</small>
                  <small className={isFullyUsed ? 'text-success' : 'text-primary'}>{percentage}%</small>
                </div>
                <div className="progress" style={{ height: '6px' }}>
                  <div
                    className={`progress-bar ${isFullyUsed ? 'bg-success' : 'bg-info'}`}
                    role="progressbar"
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'no_of_redeem',
        label: 'Max Uses',
        options: { 
          filter: true, 
          sort: true,
          display: false,
        },
      },
      {
        name: 'start_date',
        label: 'Valid From',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const startDate = moment(value, 'YYYY-MM-DD')
            const isUpcoming = startDate.isAfter(moment())
            const isToday = startDate.isSame(moment(), 'day')
            
            return (
              <div>
                <div style={{ fontWeight: 'bold' }}>{startDate.format('DD/MM/YYYY')}</div>
                {isToday && <small className="text-success"><i className="icofont icofont-check-circled"></i> Today</small>}
                {isUpcoming && <small className="text-info"><i className="icofont icofont-clock-time"></i> Upcoming</small>}
              </div>
            )
          },
        },
      },
      {
        name: 'end_date',
        label: 'Valid Until',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const endDate = moment(value, 'YYYY-MM-DD')
            const isExpired = endDate.isBefore(moment(), 'day')
            const isExpiringSoon = endDate.diff(moment(), 'days') <= 7 && !isExpired
            const isToday = endDate.isSame(moment(), 'day')
            
            return (
              <div>
                <div style={{ fontWeight: 'bold' }}>{endDate.format('DD/MM/YYYY')}</div>
                {isExpired && <small className="text-danger"><i className="icofont icofont-warning"></i> Expired</small>}
                {isToday && <small className="text-warning"><i className="icofont icofont-warning"></i> Expires Today</small>}
                {isExpiringSoon && !isToday && <small className="text-warning"><i className="icofont icofont-clock-time"></i> Expires in {endDate.diff(moment(), 'days')} days</small>}
              </div>
            )
          },
        },
      },
      {
        name: 'start_time',
        label: 'Start Time',
        options: { 
          filter: false, 
          sort: true,
          display: false,
        },
      },
      {
        name: 'end_time',
        label: 'End Time',
        options: { 
          filter: false, 
          sort: true,
          display: false,
        },
      },
      {
        name: 'status',
        label: 'Redemption Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            const used = tableMeta.rowData[9] || 0
            const total = tableMeta.rowData[10] || 0
            const remaining = total - used
            
            let badgeClassName, icon, text
            
            if (value === 'Redeemed') {
              badgeClassName = 'badge badge-success'
              icon = 'icofont-check-circled'
              text = 'Fully Redeemed'
            } else if (remaining > 0 && remaining <= 5) {
              badgeClassName = 'badge badge-warning'
              icon = 'icofont-warning'
              text = `${remaining} Left`
            } else {
              badgeClassName = 'badge badge-info'
              icon = 'icofont-refresh'
              text = `${remaining} Available`
            }

            return (
              <span className={badgeClassName}>
                <i className={`${icon} mr-1`}></i>
                {text}
              </span>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Active Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (active, tableMeta) => {
            return (
              <div className="d-flex align-items-center">
                <Toggle
                  id={`active-${tableMeta.rowData[0]}`}
                  checked={active === true ? true : false}
                  value={active}
                  onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !active)}
                />
                <small className={`ml-2 ${active ? 'text-success' : 'text-danger'}`} style={{ fontWeight: 'bold' }}>
                  {active ? 'Active' : 'Inactive'}
                </small>
              </div>
            )
          },
        },
      },
      {
        name: 'show_on_checkout',
        label: 'Checkout Page',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (show_on_checkout, tableMeta) => {
            return (
              <div className="d-flex align-items-center">
                <Toggle
                  id={`checkout-${tableMeta.rowData[0]}`}
                  checked={show_on_checkout === true ? true : false}
                  value={show_on_checkout}
                  onChange={this.handleCheckoutStatusChange.bind(this, tableMeta.rowData[0], !show_on_checkout)}
                />
                <small className={`ml-2 ${show_on_checkout ? 'text-success' : 'text-muted'}`} style={{ fontWeight: 'bold' }}>
                  {show_on_checkout ? 'Visible' : 'Hidden'}
                </small>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => {
            return (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ gap: '12px' }}
              >
                <div
                  onClick={() => this.showCouponDetails(id)}
                  title="View Details"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="f-20 icofont icofont-eye text-info"></i>
                </div>
                {localStorage.getItem('user_role') !== 'ops-coord' && (
                  <>
                    <div
                      onClick={() => this.editCoupon(id)}
                      title="Edit Coupon"
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="f-20 icofont icofont-ui-edit text-primary"></i>
                    </div>
                    <div
                      onClick={() => {
                        Swal.fire({
                          title: 'Are you sure?',
                          text: "You won't be able to revert this!",
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'Yes, delete it!'
                        }).then((result) => {
                          if (result.isConfirmed) {
                            this.deleteCoupon(id)
                          }
                        })
                      }}
                      title="Delete Coupon"
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="f-20 icofont icofont-ui-delete text-danger"></i>
                    </div>
                  </>
                )}
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: true,
      selectableRows: true,
      filter: false,
      search: false,
      textLabels: {
        body: {
          noMatch: this.state.isListLoading ? <Loader open={this.state.isListLoading} /> : 'Sorry, No Coupon Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },

      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
        return (
          <div
            className="p-r-20"
            onClick={() => {
              this.deleteCoupons(selectedRows, displayData, setSelectedRows)
            }}
          >
            <i className="f-20 icofont icofont-delete-alt text-danger"></i>
          </div>
        )
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            count={this.state.search.limit}
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            pageNumber={this.state.search.pageNumber || 0}
            totalPages={this.state.search.totalPages}
            type="coupon"
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          (prevState) => ({
            search: {
              ...prevState.search,
              pageNumber: currentPage,
            },
            userList: [],
          }),
          () => {
            this.CouponLists()
          }
        )
      },

      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          (prevState) => ({
            search: {
              ...prevState.search,
              limit: numberOfRows,
            },
            // userList: [], // You can keep or remove this depending on your requirement
          }),
          () => {
            this.CouponLists()
          }
        )
      },
      // customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
    }

    return (
      <div>
        <div>
          {/* <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Create Bulk Coupon</h4>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {localStorage.getItem('user_role') !== 'ops-coord' && (
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <BulkCouponForm
                      language_id={this.state.language_id}
                      list={this.state.list}
                      categoryList={this.state.categoryList}
                      editCouponId={this.state.editCouponId}
                      editCouponData={this.state.editCouponData}
                      clearEdit={this.clearEdit}
                      reloadList={this.reloadList}
                    ></BulkCouponForm>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Coupon list</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        title={customToolbar()}
                        className="table-responsive"
                        data={this.state.couponList}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {couponViewer()}
      </div>
    )
  }
}

export default BulkCoupon
